Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.callGuardDEV = void 0;
exports.initializeUIRuntime = initializeUIRuntime;
exports.setupConsole = exports.setupCallGuard = void 0;
var _errors = require("./errors");
var _PlatformChecker = require("./PlatformChecker");
var _threads = require("./threads");
var _utils = require("./utils");
var IS_JEST = (0, _PlatformChecker.isJest)();
var IS_NATIVE = !(0, _PlatformChecker.shouldBeUseWeb)();
var IS_CHROME_DEBUGGER = (0, _PlatformChecker.isChromeDebugger)();
var _worklet_7535208113410_init_data = {
    code: "function callGuardDEV(fn,...args){try{fn(...args);}catch(e){if(global.__ErrorUtils){global.__ErrorUtils.reportFatalError(e);}else{throw e;}}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts",
    sourceMap: '{"version":3,"names":["callGuardDEV","fn","args","e","global","__ErrorUtils","reportFatalError"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts"],"mappings":"AAeO,SAAAA,YAASA,CAAaC,EAC3B,CAAqB,GACrBC,IAAG,CACJ,CAEC,GAAI,CACFD,EAAE,CAAC,GAAGC,IAAI,CAAC,CACb,CAAE,MAAOC,CAAC,CAAE,CACV,GAAIC,MAAM,CAACC,YAAY,CAAE,CACvBD,MAAM,CAACC,YAAY,CAACC,gBAAgB,CAACH,CAAU,CAAC,CAClD,CAAC,IAAM,CACL,KAAM,CAAAA,CAAC,CACT,CACF,CACF"}',
    version: "3.5.4"
};
var callGuardDEV = exports.callGuardDEV = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var callGuardDEV = function callGuardDEV(fn) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        try {
            fn.apply(void 0, args);
        } catch (e) {
            if (global.__ErrorUtils) {
                global.__ErrorUtils.reportFatalError(e);
            } else {
                throw e;
            }
        }
    };
    callGuardDEV.__closure = {};
    callGuardDEV.__initData = _worklet_7535208113410_init_data;
    callGuardDEV.__workletHash = 7535208113410;
    callGuardDEV.__stackDetails = _e;
    return callGuardDEV;
}();
var _worklet_5000844547961_init_data = {
    code: "function setupCallGuard(){const{callGuardDEV,runOnJS,reportFatalErrorOnJS}=this.__closure;global.__callGuardDEV=callGuardDEV;global.__ErrorUtils={reportFatalError:function(error){runOnJS(reportFatalErrorOnJS)({message:error.message,stack:error.stack});}};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts",
    sourceMap: '{"version":3,"names":["setupCallGuard","callGuardDEV","runOnJS","reportFatalErrorOnJS","__closure","global","__callGuardDEV","__ErrorUtils","reportFatalError","error","message","stack"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts"],"mappings":"AA+BO,SAAAA,cAASA,CAAA,CAAc,OAAAC,YAAA,CAAAC,OAAA,CAAAC,oBAAA,OAAAC,SAAA,CAE5BC,MAAM,CAACC,cAAc,CAAGL,YAAY,CACpCI,MAAM,CAACE,YAAY,CAAG,CACpBC,gBAAgB,CAAE,QAAAA,CAACC,KAAY,CAAK,CAClCP,OAAO,CAACC,oBAAoB,CAAC,CAAC,CAC5BO,OAAO,CAAED,KAAK,CAACC,OAAO,CACtBC,KAAK,CAAEF,KAAK,CAACE,KACf,CAAC,CAAC,CACJ,CACF,CAAC,CACH"}',
    version: "3.5.4"
};
var setupCallGuard = exports.setupCallGuard = function() {
    var _e = [
        new global.Error(),
        -4,
        -27
    ];
    var setupCallGuard = function setupCallGuard() {
        global.__callGuardDEV = callGuardDEV;
        global.__ErrorUtils = {
            reportFatalError: function reportFatalError(error) {
                (0, _threads.runOnJS)(_errors.reportFatalErrorOnJS)({
                    message: error.message,
                    stack: error.stack
                });
            }
        };
    };
    setupCallGuard.__closure = {
        callGuardDEV: callGuardDEV,
        runOnJS: _threads.runOnJS,
        reportFatalErrorOnJS: _errors.reportFatalErrorOnJS
    };
    setupCallGuard.__initData = _worklet_5000844547961_init_data;
    setupCallGuard.__workletHash = 5000844547961;
    setupCallGuard.__stackDetails = _e;
    return setupCallGuard;
}();
var capturableConsole = Object.assign({}, console);
var _worklet_3852058212244_init_data = {
    code: "function setupConsole(){const{IS_CHROME_DEBUGGER,runOnJS,capturableConsole}=this.__closure;if(!IS_CHROME_DEBUGGER){global.console={assert:runOnJS(capturableConsole.assert),debug:runOnJS(capturableConsole.debug),log:runOnJS(capturableConsole.log),warn:runOnJS(capturableConsole.warn),error:runOnJS(capturableConsole.error),info:runOnJS(capturableConsole.info)};}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts",
    sourceMap: '{"version":3,"names":["setupConsole","IS_CHROME_DEBUGGER","runOnJS","capturableConsole","__closure","global","console","assert","debug","log","warn","error","info"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts"],"mappings":"AAgDO,SAAAA,YAASA,CAAA,CAAY,OAAAC,kBAAA,CAAAC,OAAA,CAAAC,iBAAA,OAAAC,SAAA,CAE1B,GAAI,CAACH,kBAAkB,CAAE,CAEvBI,MAAM,CAACC,OAAO,CAAG,CACfC,MAAM,CAAEL,OAAO,CAACC,iBAAiB,CAACI,MAAM,CAAC,CACzCC,KAAK,CAAEN,OAAO,CAACC,iBAAiB,CAACK,KAAK,CAAC,CACvCC,GAAG,CAAEP,OAAO,CAACC,iBAAiB,CAACM,GAAG,CAAC,CACnCC,IAAI,CAAER,OAAO,CAACC,iBAAiB,CAACO,IAAI,CAAC,CACrCC,KAAK,CAAET,OAAO,CAACC,iBAAiB,CAACQ,KAAK,CAAC,CACvCC,IAAI,CAAEV,OAAO,CAACC,iBAAiB,CAACS,IAAI,CACtC,CAAC,CACH,CACF"}',
    version: "3.5.4"
};
var setupConsole = exports.setupConsole = function() {
    var _e = [
        new global.Error(),
        -4,
        -27
    ];
    var setupConsole = function setupConsole() {
        if (!IS_CHROME_DEBUGGER) {
            global.console = {
                assert: (0, _threads.runOnJS)(capturableConsole.assert),
                debug: (0, _threads.runOnJS)(capturableConsole.debug),
                log: (0, _threads.runOnJS)(capturableConsole.log),
                warn: (0, _threads.runOnJS)(capturableConsole.warn),
                error: (0, _threads.runOnJS)(capturableConsole.error),
                info: (0, _threads.runOnJS)(capturableConsole.info)
            };
        }
    };
    setupConsole.__closure = {
        IS_CHROME_DEBUGGER: IS_CHROME_DEBUGGER,
        runOnJS: _threads.runOnJS,
        capturableConsole: capturableConsole
    };
    setupConsole.__initData = _worklet_3852058212244_init_data;
    setupConsole.__workletHash = 3852058212244;
    setupConsole.__stackDetails = _e;
    return setupConsole;
}();
var _worklet_7781445156117_init_data = {
    code: "function setupRequestAnimationFrame(){const{callMicrotasks}=this.__closure;const nativeRequestAnimationFrame=global.requestAnimationFrame;let animationFrameCallbacks=[];let lastNativeAnimationFrameTimestamp=-1;global.__flushAnimationFrame=function(frameTimestamp){const currentCallbacks=animationFrameCallbacks;animationFrameCallbacks=[];currentCallbacks.forEach(function(f){return f(frameTimestamp);});callMicrotasks();};global.requestAnimationFrame=function(callback){animationFrameCallbacks.push(callback);if(animationFrameCallbacks.length===1){nativeRequestAnimationFrame(function(timestamp){if(lastNativeAnimationFrameTimestamp>=timestamp){return;}lastNativeAnimationFrameTimestamp=timestamp;global.__frameTimestamp=timestamp;global.__flushAnimationFrame(timestamp);global.__frameTimestamp=undefined;});}return-1;};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts",
    sourceMap: '{"version":3,"names":["setupRequestAnimationFrame","callMicrotasks","__closure","nativeRequestAnimationFrame","global","requestAnimationFrame","animationFrameCallbacks","lastNativeAnimationFrameTimestamp","__flushAnimationFrame","frameTimestamp","currentCallbacks","forEach","f","callback","push","length","timestamp","__frameTimestamp","undefined"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts"],"mappings":"AA+DA,SAAAA,0BAASA,CAAA,CAA0B,OAAAC,cAAA,OAAAC,SAAA,CAKjC,KAAM,CAAAC,2BAA2B,CAAGC,MAAM,CAACC,qBAAqB,CAEhE,GAAI,CAAAC,uBAA2D,CAAG,EAAE,CACpE,GAAI,CAAAC,iCAAiC,CAAG,CAAC,CAAC,CAE1CH,MAAM,CAACI,qBAAqB,CAAG,SAACC,cAAsB,CAAK,CACzD,KAAM,CAAAC,gBAAgB,CAAGJ,uBAAuB,CAChDA,uBAAuB,CAAG,EAAE,CAC5BI,gBAAgB,CAACC,OAAO,CAAE,SAAAC,CAAC,QAAK,CAAAA,CAAC,CAACH,cAAc,CAAC,GAAC,CAClDR,cAAc,CAAC,CAAC,CAClB,CAAC,CAEDG,MAAM,CAACC,qBAAqB,CAAG,SAC7BQ,QAAqC,CAC1B,CACXP,uBAAuB,CAACQ,IAAI,CAACD,QAAQ,CAAC,CACtC,GAAIP,uBAAuB,CAACS,MAAM,GAAK,CAAC,CAAE,CAIxCZ,2BAA2B,CAAE,SAAAa,SAAS,CAAK,CACzC,GAAIT,iCAAiC,EAAIS,SAAS,CAAE,CAElD,OACF,CACAT,iCAAiC,CAAGS,SAAS,CAC7CZ,MAAM,CAACa,gBAAgB,CAAGD,SAAS,CACnCZ,MAAM,CAACI,qBAAqB,CAACQ,SAAS,CAAC,CACvCZ,MAAM,CAACa,gBAAgB,CAAGC,SAAS,CACrC,CAAC,CAAC,CACJ,CAKA,MAAO,CAAC,CAAC,CACX,CAAC,CACH"}',
    version: "3.5.4"
};
var setupRequestAnimationFrame = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var setupRequestAnimationFrame = function setupRequestAnimationFrame() {
        var nativeRequestAnimationFrame = global.requestAnimationFrame;
        var animationFrameCallbacks = [];
        var lastNativeAnimationFrameTimestamp = -1;
        global.__flushAnimationFrame = function(frameTimestamp) {
            var currentCallbacks = animationFrameCallbacks;
            animationFrameCallbacks = [];
            currentCallbacks.forEach(function(f) {
                return f(frameTimestamp);
            });
            (0, _threads.callMicrotasks)();
        };
        global.requestAnimationFrame = function(callback) {
            animationFrameCallbacks.push(callback);
            if (animationFrameCallbacks.length === 1) {
                nativeRequestAnimationFrame(function(timestamp) {
                    if (lastNativeAnimationFrameTimestamp >= timestamp) {
                        return;
                    }
                    lastNativeAnimationFrameTimestamp = timestamp;
                    global.__frameTimestamp = timestamp;
                    global.__flushAnimationFrame(timestamp);
                    global.__frameTimestamp = undefined;
                });
            }
            return -1;
        };
    };
    setupRequestAnimationFrame.__closure = {
        callMicrotasks: _threads.callMicrotasks
    };
    setupRequestAnimationFrame.__initData = _worklet_7781445156117_init_data;
    setupRequestAnimationFrame.__workletHash = 7781445156117;
    setupRequestAnimationFrame.__stackDetails = _e;
    return setupRequestAnimationFrame;
}();
var _worklet_57184292613_init_data = {
    code: "function anonymous(){const{setupCallGuard,setupConsole,IS_NATIVE,setupMicrotasks,setupRequestAnimationFrame}=this.__closure;setupCallGuard();setupConsole();if(IS_NATIVE){setupMicrotasks();setupRequestAnimationFrame();}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts",
    sourceMap: '{"version":3,"names":["anonymous","setupCallGuard","setupConsole","IS_NATIVE","setupMicrotasks","setupRequestAnimationFrame","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/initializers.ts"],"mappings":"AAsHqB,SAAAA,SAAMA,CAAA,QAAAC,cAAA,CAAAC,YAAA,CAAAC,SAAA,CAAAC,eAAA,CAAAC,0BAAA,OAAAC,SAAA,CAEvBL,cAAc,CAAC,CAAC,CAChBC,YAAY,CAAC,CAAC,CACd,GAAIC,SAAS,CAAE,CACbC,eAAe,CAAC,CAAC,CACjBC,0BAA0B,CAAC,CAAC,CAC9B,CACF"}',
    version: "3.5.4"
};
function initializeUIRuntime() {
    if (IS_JEST) {
        globalThis.requestAnimationFrame = _utils.mockedRequestAnimationFrame;
    }
    (0, _threads.runOnUIImmediately)(function() {
        var _e = [
            new global.Error(),
            -6,
            -27
        ];
        var anonymous = function anonymous() {
            setupCallGuard();
            setupConsole();
            if (IS_NATIVE) {
                (0, _threads.setupMicrotasks)();
                setupRequestAnimationFrame();
            }
        };
        anonymous.__closure = {
            setupCallGuard: setupCallGuard,
            setupConsole: setupConsole,
            IS_NATIVE: IS_NATIVE,
            setupMicrotasks: _threads.setupMicrotasks,
            setupRequestAnimationFrame: setupRequestAnimationFrame
        };
        anonymous.__initData = _worklet_57184292613_init_data;
        anonymous.__workletHash = 57184292613;
        anonymous.__stackDetails = _e;
        return anonymous;
    }())();
}
